import { render } from "./payment-confirmation.vue?vue&type=template&id=2bd4175e&scoped=true&ts=true"
import script from "./payment-confirmation.vue?vue&type=script&lang=ts"
export * from "./payment-confirmation.vue?vue&type=script&lang=ts"

import "./payment-confirmation.vue?vue&type=style&index=0&id=2bd4175e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd4175e"]])

export default __exports__